import axios from 'axios'

import dotenv from 'global/environment'

import { handleHttpError } from './handleHttpError'

const axiosInstance = axios.create({
  baseURL: dotenv.apiBaseUrl,
  withCredentials: true
})

function makeHttpRequest(apiCall) {
  return new Promise(async (resolve, reject) => {
    try {
      const defaultTimezone = Intl.DateTimeFormat().resolvedOptions()
        .timeZone

      axiosInstance.defaults.headers.common.timezone = defaultTimezone

      const req = await apiCall()
      resolve(req.data)
    } catch (e) {
      reject(handleHttpError(e))
    }
  })
}

export const getRequest = (path, options = {}) => {
  return makeHttpRequest(() => axiosInstance.get(path, options))
}

export const postRequest = (path, data, options = {}) => {
  // eslint-disable-next-line no-console
  console.log('PATH ==============> ', path)
  return makeHttpRequest(() =>
    axiosInstance.post(path, data, options)
  )
}

export const putRequest = (path, data, options = {}) => {
  return makeHttpRequest(() =>
    axiosInstance.put(path, data, options)
  )
}

export const deleteRequest = (path, options = {}) => {
  return makeHttpRequest(() =>
    axiosInstance.delete(path, options)
  )
}

export const patchRequest = (path, data, options = {}) => {
  return makeHttpRequest(() =>
    axiosInstance.patch(path, data, options)
  )
}
